// extracted by css-extract-rspack-plugin
export default {"OutsourcedAccountantReviewSection":"sputnik__OutsourcedAccountantReviewSection__GKUTb","outsourcedAccountantReviewSection":"sputnik__OutsourcedAccountantReviewSection__GKUTb"};